export default __webpack_public_path__ + "static/media/background-account-signup.0ad1ea6e.jpg";